import { CartOrderInstance } from "./cartTypes"
import { DbEntry } from "../types"

export async function createOrder(
  order: CartOrderInstance[],
  accessToken?: string,
  buyerId?: string,
  note?: string
): Promise<
  DbEntry<{ buyer: string; order: CartOrderInstance[]; note?: string }>
> {
  try {
    const response = await fetch("/.netlify/functions/orderCreate", {
      method: "POST",
      body: JSON.stringify({ order, note, buyerId }),
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    if (response.ok) return response.json()
    throw new Error("Could not Create order!")
  } catch (err) {
    // @ts-ignore
    throw new Error(err)
  }
}
